import { UploadSessionStatus } from '@/shared/api/protocol-ts/model/dto_upload_session_pb';
import clearCat from '@/shared/assets/images/cats/clear.png';
import errorCat from '@/shared/assets/images/cats/error.png';
import smileCat from '@/shared/assets/images/cats/smile.png';

export const studyStatusData: Record<
  number,
  { imageSrc: string; status: UploadSessionStatus }
> = {
  [UploadSessionStatus.UploadSessionStatusInProgress]: {
    imageSrc: clearCat,
    status: UploadSessionStatus.UploadSessionStatusInProgress,
  },
  [UploadSessionStatus.UploadSessionStatusSuccessful]: {
    imageSrc: smileCat,
    status: UploadSessionStatus.UploadSessionStatusSuccessful,
  },
  [UploadSessionStatus.UploadSessionStatusFailed]: {
    imageSrc: errorCat,
    status: UploadSessionStatus.UploadSessionStatusFailed,
  },
  [UploadSessionStatus.UploadSessionStatusCancelled]: {
    imageSrc: errorCat,
    status: UploadSessionStatus.UploadSessionStatusCancelled,
  },
  [UploadSessionStatus.UploadSessionStatusClosing]: {
    imageSrc: errorCat,
    status: UploadSessionStatus.UploadSessionStatusClosing,
  },
  [UploadSessionStatus.UploadSessionStatusToBeClosed]: {
    imageSrc: errorCat,
    status: UploadSessionStatus.UploadSessionStatusToBeClosed,
  },
};
